import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import PrintIcon from '@mui/icons-material/Print';
import { useTranslate } from "src/locales";
//OAERDOGAN;447740;05032025
interface ByzNursePrintButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
}
const StyledButton = styled(Button)<{ popup?: boolean }>(({ popup }) => ({
  width: "96px",
  height: "36px",
  borderRadius: "20px",
  padding: "4px 10px",
  gap: "6px",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "22px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  border: "1px solid #2979C3",
  backgroundColor: "#63B4FF33",
  color: "#2979C3",
  "&:hover": {
    backgroundColor: "#2979C3",
    color: "#fff",
  },
  "&.Mui-disabled": {
    border: "1px solid #E0E0E0",
    backgroundColor: "#F5F5F5",
    color: "#AAB4BE",
  },
}));

const ByzNursePrintButton: React.FC<ByzNursePrintButtonProps> = ({ onClick, link, popup, disabled, ...props }) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  const buttonContent = (
    <>
      <PrintIcon
        style={{
          width: "16px",
          height: "16px",
          marginRight: "5px",
          transition: "0.2s ease-in-out",

        }}
      />
      <ByzMuiTypography
        fontWeight={400}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "5px",
        }}
      >
        {t("print.print")}

      </ByzMuiTypography>
    </>
  );

  if (link && !disabled) {
    return (
      <Link to={link} style={{ textDecoration: "none" }}>
        <StyledButton
          popup={popup}
          disabled={disabled}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          {...props}
        >
          {buttonContent}
        </StyledButton>
      </Link>
    );
  }

  return (
    <StyledButton
      popup={popup}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...props}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzNursePrintButton;
